export default __webpack_public_path__ + "static/media/doctors-box1.bd3b7cac.svg";